import { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { CardHeaderDropDownProps } from "../../types/common-elements/CommonElementsTypes";
const CardHeaderDropDown = ({firstItem , secondItem ,thirdItem ,mainTitle,menuTitle,onDropdownAction}:CardHeaderDropDownProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  return (
    <Dropdown className="icon-dropdown" isOpen={dropdownOpen} toggle={toggle} >
      <DropdownToggle caret color="">
        {mainTitle ? <i className="icon-more-alt" /> : menuTitle }
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem onClick={() => onDropdownAction && onDropdownAction(firstItem || "")}>
          {firstItem}
        </DropdownItem>
        <DropdownItem onClick={() => onDropdownAction && onDropdownAction(secondItem || "")}>
          {secondItem}
        </DropdownItem>
        <DropdownItem onClick={() => onDropdownAction && onDropdownAction(thirdItem || "")}>
          {thirdItem}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default CardHeaderDropDown;
